import React, { useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Navbar } from "../../component/navbar";

import { Footer } from "../../component/footer";
import animate from "../../assets/js/animate";
import logoCircle from "../../assets/images/logoCircle.png";
import logoC from "../../assets/images/logoC.png";
import workWithImg from "../../assets/images/workWithImg.png";
import arrowRight from "../../assets/images/arrowRight.svg";
import leftArrow from "../../assets/images/leftArrow.svg";
import whoWeImg from "../../assets/images/whoWeImg.jpg";
import influnceIco1 from "../../assets/images/influnceIco1.svg";
import influnceIco2 from "../../assets/images/influnceIco2.svg";
import influnceIco3 from "../../assets/images/influnceIco3.svg";
import influnceIco4 from "../../assets/images/influnceIco4.svg";
import influnceIco5 from "../../assets/images/influnceIco5.svg";
import story1 from "../../assets/images/story1.png";
import story2 from "../../assets/images/story2.png";
import story3 from "../../assets/images/story3.png";
import influenceImg from "../../assets/images/influenceImg.png";
import logoText from "../../assets/images/logoText.png";

import service1 from "../../assets/images/service1.png";
import service2 from "../../assets/images/service2.png";
import service3 from "../../assets/images/service3.png";
import service4 from "../../assets/images/service4.png";
import service5 from "../../assets/images/service5.png";
import service6 from "../../assets/images/service6.png";
import service7 from "../../assets/images/service7.png";
import service8 from "../../assets/images/service8.png";
import service9 from "../../assets/images/service9.png";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const settings1 = {
  dots: false,
  infinite: true,
  speed: 900,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  pauseOnHover: false,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
  ],
};

const servicesData = [
  {
    background: "#F5451E",
    icon: service1,
    title: (
      <>
        Influencer
        <br />
        Leads
      </>
    ),
  },
  {
    background: "#32D3C4",
    icon: service2,
    title: (
      <>
        Influence
        <br />
        Management
      </>
    ),
  },
  {
    background: "#6D23C0",
    icon: service3,
    title: (
      <>
        Content
        <br />
        Creation
      </>
    ),
  },
  {
    background: "#024EAC",
    icon: service4,
    title: "Influencer Business Management",
  },
  {
    background: "#DF345E",
    icon: service5,
    title: (
      <>
        Influencer
        <br />
        Sales
      </>
    ),
  },
  {
    background: "#32D3C4",
    icon: service6,
    title: (
      <>
        Social
        <br />
        Media
      </>
    ),
  },
  {
    background: "#FC8E01",
    icon: service7,
    title: "Social Media Management",
  },
  {
    background: "#4D2391",
    icon: service8,
    title: (
      <>
        Digital
        <br />
        PR
      </>
    ),
  },
  {
    background: "#FD5F56",
    icon: service9,
    title: "Done for You Business Needs",
  },
];

export const Home = () => {
  const ref = useRef(null);

  useEffect(() => {
    animate();
  }, []);

  const handleNextSlide = () => {
    ref.current.slickNext();
  };

  const handlePrevSlide = () => {
    ref.current.slickPrev();
  };

  const typeAnimation = () => {
    const words = [
      "Your Influence, Our Expertise – All in One Place",
      "We Build, Manage & Grow Your Influence – Seamlessly",
      "We Do It All for You – Build, Manage, and Scale Your Influence",
    ];
    const dynamicText = document.getElementById("dynamic-text");

    let wordIndex = 0;
    let letterIndex = 0;
    let isDeleting = false;
    let typingSpeed = 120;
    let deletingSpeed = 60;
    let pauseBetweenWords = 1500;

    function type() {
      const currentWord = words[wordIndex];

      if (!isDeleting) {
        dynamicText.textContent = currentWord.slice(0, letterIndex + 1);
        letterIndex++;

        if (letterIndex === currentWord.length) {
          isDeleting = true;
          setTimeout(type, pauseBetweenWords);
          return;
        }
      } else {
        dynamicText.textContent = currentWord.slice(0, letterIndex - 1);
        letterIndex--;

        if (letterIndex === 0) {
          isDeleting = false;
          wordIndex = (wordIndex + 1) % words.length;
        }
      }
      setTimeout(type, isDeleting ? deletingSpeed : typingSpeed);
    }

    type();
  };

  useEffect(() => {
    typeAnimation();
  }, []);

  return (
    <div className="homePage">
      <header className="header homePage" id="header">
        <Navbar />

        <section className="headerSection">
          <div className="container">
            <div className="logoM">
              <div className="logo">
                <div className="logoCircle">
                  <img src={logoCircle} alt="icon" />
                </div>
                <div className="logoC">
                  <img src={logoC} alt="icon" />
                </div>
              </div>
              <div className="logoText">
                <img src={logoText} alt="" />
              </div>
            </div>
            <div className="animatable slideInUp animationDelay300">
              <h1 className="main-title">
                <span class="dynamic-text" id="dynamic-text"></span>
              </h1>
            </div>
            <div className="animatable slideInUp animationDelay500">
              <p className="para">
                From growing your audience to building e-learning products,
                Capital Media helps brands and creators connect and thrive
                online.
              </p>
            </div>
            <div className="mt-5 text-center animatable slideInUp animationDelay500">
              {/* <Link className="getStatedBtn" to="/contact">
                Get a Demo
              </Link> */}
              <a
                href="https://calendly.com/capitalmediausa-info/30min"
                className="getStatedBtn"
                target="_blank"
              >
                Schedule a Free Strategy Session
              </a>
              {/* <button className="buyCoinBtn ml-3">Whitepaper</button> */}
            </div>
          </div>
        </section>
      </header>

      <section className="workWith">
        <div className="container">
          <div className="row ai-center">
            <div className="col-md-6">
              <div className="content">
                <div className="homeHeading animatable slideInUp">
                  Who We Work With
                </div>
                <div className="tagline animatable slideInUp animationDelay100">
                  At Capital Media LLC, we empower a diverse range of clients:
                </div>

                <div className="categoryRow active animatable slideInRight ">
                  <div className="ico">
                    <img src={arrowRight} alt="->" />
                  </div>
                  <p>Entrepreneurs and Startups</p>
                </div>
                <div className="categoryRow animatable slideInRight animationDelay200">
                  <div className="ico">
                    <img src={arrowRight} alt="->" />
                  </div>
                  <p>Educational Institutions & E-learning Platforms</p>
                </div>
                <div className="categoryRow animatable slideInRight animationDelay300">
                  <div className="ico">
                    <img src={arrowRight} alt="->" />
                  </div>
                  <p>Influencers & Creators</p>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="imgDiv">
                <img src={workWithImg} alt="work with" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="whoWe" id="about">
        <div className="container">
          <div className="row ai-center">
            <div className="col-md-6">
              <div className="imgDiv">
                <img src={whoWeImg} alt="" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="content">
                <div className="homeHeading animatable slideInUp">
                  Who We Are
                </div>
                <div className="desc mb-4 animatable slideInUp animationDelay100">
                  We are a one-stop platform dedicated to building, managing,
                  and growing your influence across all digital channels. From
                  strategy and branding to content creation and platform
                  management, we handle everything for you—delivering
                  professional results for a fraction of the cost. Our mission
                  is to empower individuals and businesses to amplify their
                  presence, engage their audience, and achieve measurable impact
                  without the hassle of managing multiple services or
                  providers.{" "}
                </div>
                <div className="mGuru">Marketing Guru!</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="influenceSol" id="solutions">
        <div className="container">
          <div className="homeHeading text-center animatable slideInUp">
            Influencer Solutions
          </div>
          <div className="tagline text-center animatable slideInUp">
            Discover how we’ve helped creators grow faster, earn more, and
            launch with confidence.
          </div>
          <div className="row">
            <div className="col-lg-4 col-sm-6 mb-4 animatable flipInY animationDelay100">
              <ICard
                icon={influnceIco1}
                title="Personal Brand Strategy"
                point1={"Positioning and storytelling"}
                point2={"Content planning to attract followers and sponsors"}
              />
            </div>
            <div className="col-lg-4 col-sm-6 mb-4 animatable flipInY animationDelay200">
              <ICard
                icon={influnceIco2}
                title="Social Media Growth"
                point1={"Daily posting and community management"}
                point2={"Trend monitoring and engagement optimization"}
              />
            </div>
            <div className="col-lg-4 col-sm-6 mb-4 animatable flipInY animationDelay300">
              <ICard
                icon={influnceIco3}
                title="Sponsorships & Partnerships"
                point1={"Outreach to brands and agencies"}
                point2={"Negotiation support and campaign management"}
              />
            </div>
            <div className="col-lg-4 col-sm-6 mb-4 animatable flipInY animationDelay100">
              <ICard
                icon={influnceIco4}
                title="Content Production"
                point1={"Branded templates and design assets"}
                point2={"Professional video editing, thumbnails, and visuals"}
              />
            </div>
            <div className="col-lg-4 col-sm-6 mb-4 animatable flipInY animationDelay200">
              <ICard
                icon={influnceIco5}
                title="E-Learning & Monetization"
                point1={"Create and sell your own courses or digital products"}
                point2={"Set up membership platforms or exclusive content hubs"}
              />
            </div>
            <div className="col-lg-4 col-sm-6 mb-4 animatable flipInY animationDelay300">
              <div className="iCard2">
                <div className="title">
                  Let’s build your brand and income — starting today.
                </div>
                <a
                  href="https://calendly.com/capitalmediausa-info/30min"
                  target="_blank"
                  className="themeBtn"
                >
                  Schedule a Free Strategy Session
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="servicesSec" id="services">
        <div className="container">
          <div className="homeHeading text-center animatable slideInUp">
            Our Services
          </div>
          <div className="tagline text-center animatable slideInUp">
            We create, manage your subscription plateforms for your influencing
            needs. Sit and relax, let us handle everything with afractionof
            percentage. no hidden fees
          </div>
          <div className="row">
            {servicesData.map((item, key) => (
              <div
                className="col-lg-4 col-sm-6 mb-4 animatable flipInY animationDelay100"
                key={key}
              >
                <ServiceCard
                  icon={item.icon}
                  title={item.title}
                  background={item.background}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="whyInflunce">
        <div className="container">
          <div className="row ai-center">
            <div className="col-md-6">
              <div className="content">
                <div className="homeHeading animatable slideInUp">
                  Why Influencers Choose Capital Media
                </div>
                <div className="tagline animatable slideInUp animationDelay100">
                  The Trusted Growth Partner for Today’s Top Creators
                </div>
                <div className="categoryRow animatable slideInRight ">
                  <div className="num">01</div>
                  <p>Full-Service Support — from content to monetization</p>
                </div>
                <div className="categoryRow animatable slideInRight animationDelay100">
                  <div className="num">02 </div>
                  <p>
                    Proven Growth Strategies — grow your reach and engagement
                    faster
                  </p>
                </div>
                <div className="categoryRow animatable slideInRight animationDelay200">
                  <div className="num">03</div>
                  <p>
                    Monetization Expertise — turn your audience into sustainable
                    income
                  </p>
                </div>
                <div className="categoryRow animatable slideInRight animationDelay300">
                  <div className="num">04</div>
                  <p>
                    Brand-Safe Creative — look professional to sponsors and fans
                    alike
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="imgDiv">
                <img src={influenceImg} alt="work with" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="SuccessSec">
        <div className="container">
          <div className="homeHeading text-center animatable slideInUp">
            Success Stories
          </div>
          <div className="tagline text-center animatable slideInUp animationDelay100">
            See how creators and brands like you transformed their presence,
            grew their audience, and turned content into sustainable income with
            Capital Media.
          </div>
          <Slider {...settings1} ref={ref}>
            <div className="p-3">
              <SuccessCard
                name={"John Doe"}
                desig={"Lifestyle Influencer"}
                desc={
                  "“With Capital Media’s help, I doubled my followers and landed three brand deals in 90 days.”"
                }
                profile={story1}
              />
            </div>
            <div className="p-3">
              <SuccessCard
                name={"John Doe"}
                desig={"Lifestyle Influencer"}
                desc={
                  "“With Capital Media’s help, I doubled my followers and landed three brand deals in 90 days.”"
                }
                profile={story1}
              />
            </div>
            <div className="p-3">
              <SuccessCard
                name={"John Doe"}
                desig={"Lifestyle Influencer"}
                desc={
                  "“With Capital Media’s help, I doubled my followers and landed three brand deals in 90 days.”"
                }
                profile={story1}
              />
            </div>
            <div className="p-3">
              <SuccessCard
                name={"John Doe"}
                desig={"Lifestyle Influencer"}
                desc={
                  "“With Capital Media’s help, I doubled my followers and landed three brand deals in 90 days.”"
                }
                profile={story1}
              />
            </div>
          </Slider>

          <div className="navigateMain">
            <div className="left" onClick={handlePrevSlide}>
              <img src={leftArrow} alt="" />
            </div>
            <div className="right" onClick={handleNextSlide}>
              <img src={arrowRight} alt="" />
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

const ICard = ({ icon, title, point1, point2 }) => {
  return (
    <div className="iCard">
      <div className="ico">
        <img src={icon} alt="" />
      </div>
      <div className="title">{title}</div>
      <div className="point">
        <img src={arrowRight} alt="" />
        {point1}
      </div>
      <div className="point">
        <img src={arrowRight} alt="" />
        {point2}
      </div>
    </div>
  );
};
const ServiceCard = ({ icon, title, background }) => {
  const navigate = useNavigate();

  return (
    <div className="iCard" style={{ backgroundColor: background }}>
      <div className="ico">
        <img src={icon} alt="" />
      </div>
      <div className="title">{title}</div>
      <div className="learnMore" onClick={() => navigate("/contact")}>
        Learn More
      </div>
    </div>
  );
};
const SuccessCard = ({ name, desig, desc, profile }) => {
  return (
    <div className="successCard">
      <div className="pRow">
        <div className="imgDiv">
          <img src={profile} alt="" />
        </div>
        <div>
          <div className="name">{name}</div>
          <div className="desig">{desig}</div>
        </div>
      </div>
      <div className="desc">{desc}</div>
    </div>
  );
};
